let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kuHvv")).then(() => parcelRequire('8Jkrp'));